import { FC, useCallback } from 'react';

import { SetScreenType } from 'src/components/Modals/TemplateGallery/index';
import { TemplateGalleryTemplatesList } from 'src/components/Modals/TemplateGallery/components/TemplatesList';
import { useNsTHelper } from 'src/utils/i18n';
import styles from 'src/styles/common/templateGallery.module.scss';
import { GetInPersonEventsFeaturedTemplatesResponseType } from 'src/models/Modals/templateGallery';
import { apiGetInPersonEventsFeaturedTemplates } from 'src/api/organizerTemplate';
import { UiLoader } from 'src/components/UI/loaders';
import { BaseSeparateModal } from 'src/models/modals';
import { useOneRequest } from 'src/utils/hooks/useOneRequest';
import { TemplateGalleryTemplate } from 'src/components/Modals/TemplateGallery/components/Template';
import { UiButton } from 'src/components/UI/Button';
import { IconChevronRight } from 'src/components/Icons/ChevronRight';
import { useSelector } from 'react-redux';
import { deCommonCurrentPartnerSelector } from 'src/store/commonPart/selector';

type Props = BaseSeparateModal & {
  setScreen: SetScreenType;
  fromCampaignSetup: boolean;
};

export const TemplateGalleryMainInPersonScreen: FC<Props> = ({ setScreen, onClose, fromCampaignSetup }) => {
  const tHelper = useNsTHelper('modals.templateGallery', 'mainInPerson');

  const { CampaignTerminologySingular } = useSelector(deCommonCurrentPartnerSelector);

  const { response } = useOneRequest<GetInPersonEventsFeaturedTemplatesResponseType>(
    apiGetInPersonEventsFeaturedTemplates,
    {
      initialCall: true,
      saveResponse: true,
      data: {
        OverridenOrganizationID: window.managedCampaignSettings?.organizationId,
        OverridenUserID: window.managedCampaignSettings?.userId,
      },
    }
  );

  const goToAllScreen = useCallback(() => setScreen('all'), [setScreen]);

  return (
    <>
      {fromCampaignSetup ? (
        <div className={styles.heading}>{tHelper('saveTime')}</div>
      ) : (
        <div className={styles.setupSubhead}>
          <div className={styles.heading1}>
            {tHelper('continueTitle', { campaignSingularTerminology: CampaignTerminologySingular })}
          </div>

          <div className={styles.heading2}>{tHelper('exploreTemplates')}</div>
          <div className={styles.explanation2}>{tHelper('exploreTemplatesExplanation')}</div>
        </div>
      )}

      {response ? (
        <div className={styles.templatesGrid}>
          {!!response.OnlineTemplates.length && (
            <div>
              <div className={styles.templatesLabel}>{tHelper('online')}</div>

              <div className={styles.templates}>
                <TemplateGalleryTemplatesList setScreen={setScreen} items={response.OnlineTemplates} />

                <TemplateGalleryTemplate
                  onClick={goToAllScreen}
                  Name={tHelper('exploreMore')}
                  CategoryNames={[]}
                  MediaUri=""
                />
              </div>
            </div>
          )}

          {!!response.InPersonTemplates.length && (
            <div>
              <div className={styles.templatesLabel}>{tHelper('inPerson')}</div>

              <div className={styles.templates}>
                <TemplateGalleryTemplatesList setScreen={setScreen} items={response.InPersonTemplates} />

                <TemplateGalleryTemplate
                  onClick={goToAllScreen}
                  Name={tHelper('exploreMore')}
                  CategoryNames={[]}
                  MediaUri=""
                />
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className={`${styles.templates} ${styles.loading}`}>
          <UiLoader className={styles.loader} centered />
        </div>
      )}

      {fromCampaignSetup && (
        <UiButton primaryNew onClick={onClose} className={styles.skipBtn}>
          {tHelper('skipBtnText')}

          <IconChevronRight className={styles.skipBtnIcon} />
        </UiButton>
      )}
    </>
  );
};
